// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import slashCircle01Icon from "@/assets/icons/slash-circle-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type SlashCircle01IconProps = Omit<IconProps, "name">;

export function SlashCircle01Icon(props: SlashCircle01IconProps): React.ReactNode {
  return <Icon name={slashCircle01Icon} {...props} />;
}
